/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.0.0
 */
import { SUBSCRIBER_MOBILE } from '../../../../../modules/app/Api';
import { EEditableLabel } from './labelEditorTypes';

/*
* -------------------------------------------
*          API ACTIONS
* -------------------------------------------
*/


export const LABEL_EDITOR_LOAD_LIST = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_LOAD_LIST';
export const LABEL_EDITOR_LOAD_LIST_FAILED = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_LOAD_LIST_FAILED';
export const LABEL_EDITOR_LOAD_LIST_SUCCESSFUL = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_LOAD_LIST_SUCCESSFUL';

export const LABEL_EDITOR_CREATE = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_CREATE';
export const LABEL_EDITOR_CREATE_FAILED = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_CREATE_FAILED';
export const LABEL_EDITOR_CREATE_SUCCESSFUL = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_CREATE_SUCCESSFUL';

export const LABEL_EDITOR_UPDATE = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_UPDATE';
export const LABEL_EDITOR_UPDATE_FAILED = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_UPDATE_FAILED';
export const LABEL_EDITOR_UPDATE_SUCCESSFUL = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_UPDATE_SUCCESSFUL';

/*
* -------------------------------------------
*          ACTIONS
* -------------------------------------------
*/

export const LABEL_EDITOR_SEARCH = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_SEARCH';
export const LABEL_EDITOR_SET_MODAL = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_SET_MODAL';
export const LABEL_EDITOR_SWITCH = '@@b2b_portal_ui/table/labelsEditor/LABEL_EDITOR_SWITCH';

export const MapEditorTypeToLabelsApiPath: { [key in EEditableLabel]: string } = {
    [EEditableLabel.subscriberId]: SUBSCRIBER_MOBILE,
    [EEditableLabel.mobile]: SUBSCRIBER_MOBILE,
}
